import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { RevenueConcentrationEntity } from "../entities/RevenueConcentrationEntity";

export class GetRevenueConcentrationUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<RevenueConcentrationEntity> {
    return this.repository.getRevenueConcentration();
  }
}
